enum SPACE_INVADERS_SCREEN_TYPE {
  Title = 'TITLE',
  Gameplay = 'GAMEPLAY',
  Round = 'ROUND',
  GameOver = 'GAME_OVER',
}

enum PLAYER_MOVEMENT_STATE {
  Left = 'LEFT',
  Right = 'RIGHT',
  None = 'NONE',
}

export {
  SPACE_INVADERS_SCREEN_TYPE,
  PLAYER_MOVEMENT_STATE,
};
